<template>
  <div id="transparency">
    <section class="is-fullheight">
      <Navigation></Navigation>
      <div class="has-margin-top-80 has-margin-bottom-40">
        <div class="container">
          <div class="content">
            <div class="has-text-centered">
              <h1>{{ $t('future.future') }} <span class="has-text-brand">{{ $t('future.features') }}</span></h1>
              <p>{{ $t('future.subtitle') }}</p>
            </div>
            <hr />
            <div class="columns">
              <div class="column">
                <h3>{{ $t('future.feature') }} <span class="has-text-brand">{{ $t('future.rich') }}</span></h3>
                <p>
                  {{ $t('future.intro-para-1') }}
                </p>
                <p>
                  {{ $t('future.intro-para-2') }}
                </p>
              </div>
              <div class="column">
                <div class="has-text-centered">
                  <img src="@/assets/svgs/undraw_social_influencer_sgsv.svg" alt="Future of Social Media" style="max-width: 300px;">
                </div>
              </div>
            </div>
            <hr />
            <div class="has-text-centered">
              <img src="@/assets/logo.png" alt="Kona" width="80px">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

import Navigation from '@/components/Navigation'

export default {
  data() {
    return {
      showFeedsModal: false
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  methods: {

  },

  components: {
    Navigation
  }
};
</script>